import * as types from '../../actionTypes'

const initialState = {
  file: null,
  fileName: '',
  uploadResults: null,
  isLoading: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SITE_PREFERENCES_FILE_SELECTED:
    case types.SITE_PREFERENCES_FILE_SUBMITTING:
    case types.SITE_PREFERENCES_FILE_SUCCEEDED:
    case types.SITE_PREFERENCES_FILE_ERROR:
      const { error, data, type } = action
      const { data: results } = data || {}
      let file
      let fileName = ''
      if (data) {
        file = data.file
      } else {
        file = action.file
      }
      if (file) {
        fileName = file.name
      }
      return {
        ...state,
        file: file,
        fileName: fileName,
        uploadResults:
          type === types.SITE_PREFERENCES_FILE_SUCCEEDED ? results : null,
        isLoading: type === types.SITE_PREFERENCES_FILE_SUBMITTING,
        error: type === types.SITE_PREFERENCES_FILE_ERROR ? error : null,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/sitePreferences/sitePreferencesManager.js